import { common } from "./common";
import { destination } from "./destination";
import { trip } from "./trip";
import { inspiration } from "./inspiration";
import { guide } from "./guide";

// Field hints of the six editors (rez 10, F9.6): `webHints.<editor>.*` texts referenced by the
// hint registries in `apps/admin/src/lib/webHints/`. The hint meter
// (`scripts/kontrola/admin-napovedy.mjs`) loads this dictionary under the name `webHints`.
export const webHints = { common, destination, trip, inspiration, guide };
